import { isAdPreviewMode, isAdPreviewRequested } from '@repo/wemod-api-client/analytics/ad-preview-cookie';
import { useCallback, useSyncExternalStore } from 'react';
type ClientAdPreviewModeInput = {
  cookieHeader: string;
  search: string;
};
export function isClientAdPreviewMode(input: ClientAdPreviewModeInput): boolean {
  return isAdPreviewMode(input.cookieHeader) || isAdPreviewRequested(new URLSearchParams(input.search));
}
function readClientAdPreviewMode(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  return isClientAdPreviewMode({
    cookieHeader: document.cookie,
    search: window.location.search
  });
}
export function useClientAdPreviewMode() {
  const getSnapshot = _temp;
  const getServerSnapshot = _temp2;
  return useSyncExternalStore(_temp4, getSnapshot, getServerSnapshot);
}
function _temp4() {
  return _temp3;
}
function _temp3() {}
function _temp2() {
  return false;
}
function _temp() {
  return readClientAdPreviewMode();
}